import PropTypes from "prop-types";
import React from "react";

import { ResourceShape } from "../proptypes";

const ResourcesListItem = ({
  resource = {},
  onResourceClicked = jest.fn(),
  selected = false
}) => (
  <li className="p-list__item">
    <button
      className={`p-button--list p-second-level ${
        selected ? "is-selected is-light" : ""
      }`}
      type="button"
      key={resource.$uri}
      onClick={() => onResourceClicked(resource.$uri)}
      onKeyPress={() => onResourceClicked(resource.$uri)}
    >
      {resource.name}
    </button>
  </li>
);

ResourcesListItem.propTypes = {
  resource: ResourceShape.isRequired,
  onResourceClicked: PropTypes.func.isRequired,
  selected: PropTypes.bool
};

ResourcesListItem.defaultProps = {
  selected: false
};

export default ResourcesListItem;
